<template>

    <div class="empty-cart">
        <h2 class="ui icon header center aligned">
            <i class="shop icon"></i>
            <div class="content">
                {{ lang.say('TEXT_CART_EMPTY') }}
                <div class="sub header">
                    {{ lang.say('SUB_TITLE_CART_EMPTY') }}
                </div>
            </div>
         </h2>
    </div>

</template>

<script>
    import lang from '../lang';

    export default {
        data() {
            return {
                lang
            }
        }
    }
</script>

<style scoped>
    .empty-cart {
        margin: 3.5rem 0;
    }
</style>


// WEBPACK FOOTER //
// EmptyCart.vue?b61b877c